import styled from "styled-components";

export const ManageOrderWrapper = styled.div`
    border-top: 1px solid #ECECEE;
    padding-top: 15px;
`

export const Heading = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 2px;
    .react-select__control {
        border: 1px solid #e0e0e0 !important;
        border-radius: 6px;
    }
    /* .react-select__value-container {
        padding-left: 18px;
        padding-right: 10px;
    } */
    .react-select__single-value {
        font-size: 14px;

    }
    .react-select__option {
        font-size: 14px;
        padding-left: 18px;

    }
    > svg {
    width: clamp(28px,1.979vw,38px);
    height: clamp(28px,1.979vw,38px);
}
`

export const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  overflow: auto;
  min-width: 244px;
  height: 44px;
  &.responsive {
    height: clamp(38px,2.292vw,44px);
    input {
      padding: 4px clamp(10px,0.781vw,15px) 4px clamp(33px,2.292vw,44px);
      font-size: clamp(10px,0.729vw,14px);
    }
    .search-icon {
    position: absolute;
    transform: translate(clamp(14px,0.938vw,18px), clamp(12px,0.833vw,16px));
    height: clamp(10px,0.677vw,13px);
    width: clamp(10px,0.677vw,13px);
  }
  }
  .rbt-menu {
    display: none !important;
  }
  input {
    background: #ffffff;
    border-radius: 6px;
    border: solid 1px #DADADF;
    padding: 4px 15px 4px 45px;
    width: 100%;
    font-size: 14px;
    font-family: "latoregular";

    ::-webkit-input-placeholder {
      /* Edge */
      color: #A0A7B8;
      font-family: "latoregular";

    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #A0A7B8;
      font-family: "latoregular";

    }

    ::placeholder {
      color: #A0A7B8;
      font-family: "latoregular";

    }
  }
  .search-icon {
    position: absolute;
    transform: translate(18px, 16px);
  }
`;

export const FilterWrapper = styled.div`
  cursor:pointer;
  background: #005586;
  border: 1px solid rgba(125, 131, 152, 0.3);
  box-shadow: 0px 3px 6px rgba(18, 18, 18, 0.03);
  border-radius: 6px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  > svg {
    width: clamp(14px,1.042vw,20px);
    height: clamp(14px,1.042vw,20px);
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap:10px 15px;
  /* padding-bottom: 25px; */
  flex-wrap: wrap;
  justify-content: flex-end;
  .all-invoice-date-picker {
    .MuiFormHelperText-root.Mui-error {
      position: unset;
    }
   
  }
  .select__value-container {
    padding: 4px 8px;
    min-height: clamp(33px,2.292vw,44px);
    max-height: 104px;
    overflow: auto;
  }
  .select__multi-value__label {
    font-size: clamp(10px,0.729vw,14px);
  }
  .react-select__value-container {
    height: 100%;
  }
    `

export const LeftSection = styled.div`
  h4 {
    font-size: 28px;
line-height: 150%;
  font-family: "latobold";

  }
  p {
    font-size: 16px;
line-height: 150%;
color: #7D8398;
  }
`

export const DatePickerWrapper = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  .MuiInputBase-root {
    width: 140px;
  }
`
